import React from "react";
import { NavLink } from "react-router-dom";
import {
  Button,
  Header,
  Subsection,
  FooterLinks,
  DataPageContainer,
} from "./components";
import IsMobile from "./IsMobile";
import Photo4Str from "./img/photo4str.jpg";
import Photo8Str from "./img/photo8str.jpg";

import "./Home.css";
import Pdf from "./profile.pdf"

function StreamBox(props) {
  let StreamBoxClass = "StreamBox " + props.className;
  let StreamNumberClass = "StreamNumber ";
  let StreamTextClass = "StreamText ";

  if (props.isMobile) {
    StreamNumberClass += "StreamNumberMobile";
    StreamTextClass += "StreamTextMobile";
  } else {
    StreamNumberClass += "StreamNumberDesktop";
    StreamTextClass += "StreamTextDesktop";
  }

  return (
    <div className={StreamBoxClass} style={props.position}>
      <div className={StreamNumberClass}>{props.number}</div>
      <div className={StreamTextClass}>stream</div>
    </div>
  );
}

function IntroTextContent() {
  return (
    <React.Fragment>
      <div className="Title">
        Mechatronics Class of 2020 Class Profile
        <div className="Title-shadow" />
      </div>
      <div className="Subtext">
        Welcome to the first UW Mechatronics Class Profile. {"\n\n"} 
        NOTE: This site has been designed for desktop viewing. If you are viewing this on mobile, please {" "}
        <a
            target="_blank"
            rel="noopener noreferrer"
            href={Pdf}
          >
            click here for the pdf version
        </a>. {" "}
        However! This experience is not interactive and you will be missing 
        out on a lot of data! 
      </div>
      <Button>
        <NavLink className="Button-link" to={"demographics"}>
          view data
        </NavLink>
      </Button>
    </React.Fragment>
  );
}

function MobileIntro() {
  return (
    <div>
      <IntroTextContent />
      <div className="AllPhotoContainer">
        <div className="RightBox RightBoxMobile" />
        <div className="PhotoStreamContainer PhotoContainer8">
          <StreamBox number={8} className="StreamBox8" isMobile={true} />
          <img className="PhotoMobile" src={Photo8Str} alt={"8 stream class"} />
        </div>
        <div className="PhotoStreamContainer PhotoContainer4">
          <img className="PhotoMobile" src={Photo4Str} alt={"4 stream class"} />
          <StreamBox number={4} className="StreamBox4" isMobile={true} />
        </div>
      </div>
    </div>
  );
}

function DesktopIntro() {
  return (
    <div className="Intro">
      <div className="IntroLeft">
        <IntroTextContent />
      </div>
      <div className="IntroRight">
        <div className="RightBox RightBoxDesktop" />
        <div className="Photo8Container">
          <img
            className="PhotoDesktop"
            src={Photo8Str}
            alt={"8 stream class"}
          />
          <StreamBox number={8} className="StreamBox8" />
        </div>
        <div className="Photo4Container">
          <img
            className="PhotoDesktop"
            src={Photo4Str}
            alt={"4 stream class"}
          />
          <StreamBox number={4} className="StreamBox4" />
        </div>
      </div>
    </div>
  );
}

function Home() {
  return (
    <div>
      {IsMobile() ? <MobileIntro /> : <DesktopIntro />}
      <DataPageContainer>
        <Header fontSize={"4rem"}>Foreward</Header>
        <Subsection title={"Mechatronics engineering program summary"}>
          The Mechatronics Engineering (MTE) program at the University of
          Waterloo consists of nearly 200 students each year. MTE is a
          multidisciplinary program that covers a variety of topics including
          mechanical, electrical, software, and systems design engineering,
          where students begin specializing in technical topics during their 4th
          year of study. The class of 2020 is split into two groups, 4-Stream
          and 8-Stream, which dictates the work/study term pattern.
        </Subsection>
        <Subsection title={"Why did we do this survey?"}>
          The purpose of this survey is to represent the MTE class of 2020 and
          share our experiences throughout our 5 years as undergraduate students.
        </Subsection>
        <Subsection title={"About the data"}>
          There were 114 respondents out of our class of 171 students,
          representing 67% of the class. The analysis carried out in this class
          profile is under the assumption that the sample of the class surveyed
          represents the entire class. The results do not necessarily generalize
          to other engineering programs, or even other MTE cohorts. This profile
          is meant to provide an interesting overview of the experiences we’ve
          had, with the understanding that there may be biases and other factors
          that detract from the accuracy of some of the results and trends
          presented herein. The survey was conducted between June 15 - June 22,
          2020. Study terms are represented by 1A, 1B, 2A...4A, 4B, with the
          number representing the academic year and the letter representing the
          term. CAD is the currency used in all monetary analysis. For co-op
          and full-time salaries, we used an exchange rate of 1 USD = 1.3 CAD.
        </Subsection>
        <Subsection title={"Other things to note "}>
          This class profile is based on other class profiles that have been
          created by UWaterloo engineering classes, such as the{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://ndey96.github.io/syde_2019_class_profile.pdf"
          >
            SYDE 2019 class profile
          </a>{" "}
          and the{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://uw-se-2020-class-profile.github.io/profile.pdf"
          >
            SE 2020 class profile
          </a>
          . This profile is not affiliated with the MTE program or the University
          of Waterloo in any way. {"\n\n"}

          If you have any feedback for the creators of this site, please use this Google Form to submit it: {"\n"}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="          https://forms.gle/cBTjXcmJqSgj3f3n9
            "
          >
            Feedback Submission Form
          </a>. {"\n\n"}
          Learn more about {" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="          https://uwaterloo.ca/mechanical-mechatronics-engineering/future-undergraduate-students/mechatronics-engineering
            "
          >
            Mechatronics Engineering
          </a>. {"\n"}
          See the {" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="          https://ugradcalendar.uwaterloo.ca/page/ENG-Mechatronics-Engineering
            "
          >
            Mechatronics Engineering course calendar
          </a>. {"\n"}
          Learn more about {" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="          https://uwaterloo.ca/future-students/co-op
            "
          >
            co-op
          </a>. {"\n\n"}
        </Subsection>
        <Subsection>Last updated February 2021.</Subsection>
        <FooterLinks
          next={{ text: "View Demographics Data", to: "demographics" }}
        />
      </DataPageContainer>
    </div>
  );
}

export default Home;
